module.exports = __webpack_public_path__ + "assets/img/陈姣.dc14ca52.png";